/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".updater-bag[_ngcontent-%COMP%]{cursor:pointer;position:fixed;z-index:2;box-shadow:1px 2px 3px rgba(119,116,116,.3);background-color:#888;padding:10px;right:15px;bottom:15px;color:#fff;border-radius:4px}.updater-bag__content[_ngcontent-%COMP%]{font-size:.7rem;line-height:.7rem;font-weight:500}.update-checker[_ngcontent-%COMP%]{cursor:pointer;color:transparent;position:fixed;z-index:2;bottom:15px;right:15px}"];
export { styles as styles };
